import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      appPath: (state) => state.appPath,
    }),
    ...mapGetters('discount', ['getDiscountGroupById']),
  },

  methods: {
    formatPrice(price) {
      return price.toFixed(2).replace('.', ',');
    },

    vatPrice(price) {
      return this.$store.state.data.includingVat ? price * 1.21 : price;
    },

    getIcon(icon) {
      return `${this.appPath}/icons/${icon}`;
    },

    getImage(image) {
      return `${this.appPath}/images/${image}`;
    },

    getGif(gif) {
      return `${this.appPath}/gifs/${gif}`;
    },
  },
};
